import { EndPoints } from '../../api-config';
import { pageLimit } from '../../paginations/paginationLimit';
let SERVER_ADDR_V1 = EndPoints.backendHost;


export const usersByUrl = (pageNumber, searchTerm, roles, sortByTerm, sortDesc) => `${SERVER_ADDR_V1}/user?pageSize=${pageLimit}&pageNumber=${pageNumber}${searchTerm !== "" ? '&textSearch=' + searchTerm : ""}${roles !== "" ? '&roles=' + roles : ""}${sortByTerm !== "" ? '&sortBy=' + sortByTerm : ""}${sortDesc === "" ? "" : sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`;
export const usersByUrlData = () => `${SERVER_ADDR_V1}/user`;